export default "__VITE_ASSET__BWzqbXr2__"